export default "__VITE_ASSET__BJUC_Jxc__"